import { useQuery } from '@tanstack/react-query';
import { getFavoriteMeal } from '../../../api/diary-service';

const useFavoriteMeal = (favoriteId) => {
    return useQuery({
        queryKey: ['favorite-meal', favoriteId],
        queryFn: () => getFavoriteMeal(favoriteId),
        enabled: !!favoriteId,
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false
    });
};

export default useFavoriteMeal;
